import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=17a9e64e&scoped=true"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js"
import style0 from "./SidebarDropdown.vue?vue&type=style&index=0&id=17a9e64e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a9e64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a9e64e')) {
      api.createRecord('17a9e64e', component.options)
    } else {
      api.reload('17a9e64e', component.options)
    }
    module.hot.accept("./SidebarDropdown.vue?vue&type=template&id=17a9e64e&scoped=true", function () {
      api.rerender('17a9e64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SidebarDropdown.vue"
export default component.exports